import { useEffect } from "react";
import { CloseCircleGreyIcon } from "assets";

interface SampleReportModalProps {
  show: boolean;
  onClose: () => void;
}

const SAMPLE_REPORT_URL =
  "https://precisionmatch.ai/shared-report/EEE2CB4301EA40088/5824"

const SampleReportModal: React.FC<SampleReportModalProps> = ({ show, onClose }) => {
  useEffect(() => {
    if (!show) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [show, onClose]);

  if (!show) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex flex-col"
      style={{
        background: "linear-gradient(90deg, #C6E0FF 0%, #000B55 100%)",
      }}
    >
      <div
        className="absolute sm:top-8 sm:right-8 top-6 right-4 rounded-md p-px"
        style={{ background: "linear-gradient(90deg, #C6E0FF 0%, #142CC8 97.12%)" }}
      >
        <button
          onClick={onClose}
          className="flex items-center gap-2 text-white font-normal hover:opacity-80 transition-opacity rounded-[5px] px-3 py-1 md:text-lg text-base"
          style={{ background: "linear-gradient(135deg, #142CC8 0%, #000B55 100%)" }}
        >
          Close
          <CloseCircleGreyIcon className="text-white w-5 h-5 mt-0.5" />
        </button>
      </div>

      <div className="flex-1 flex items-center justify-center sm:px-10 px-4 pb-8">
        <iframe
          src={SAMPLE_REPORT_URL}
          title="Sample Precision Report"
          className="h-[80vh] w-full rounded-2xl border-0 shadow-2xl bg-white block"
        />
      </div>
    </div>
  );
};

export { SampleReportModal };
